import "./App.css";
import Login from "./login/Login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Admindashboard from "./Pages/Admindashboard";
import Admin from "./Pages/Admin";
import Layout from "./Layout/Layout";
import Company from "./Pages/Company";
import Manager from "./Pages/Manager";
import Employee from "./Pages/Employee";
import Project from "./Pages/Project";
import Department from "./Pages/Department";
import Team from "./Pages/Team";
import TaskPage from "./Pages/TaskPage";
import SubTeam from "./Pages/SubTeam";
import Msubteam from "./Pages/Msubteam";
import ProtectedRoute from "./Auth/ProtectedRoute";
import TaskUpdate from "./Pages/TaskUpdate";
import Dashboard from "./../src/Pages/Dashboard";



function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Login />} />

          {/* admin Routes */}
          <Route
            exact
            path="/admindashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Layout>
                  <Admindashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={["manager", "employee", "Team Leader"]}>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/clientcompany"
            element={
              <ProtectedRoute allowedRoles={["admin", "employee"]}>
                <Layout>
                  <Company />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/manager"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Layout>
                  <Manager />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/employee"
            element={
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <Layout>
                  <Employee />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/project"
            element={
              <ProtectedRoute allowedRoles={["admin", "manager", "employee"]}>
                <Layout>
                  <Project />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/team"
            element={
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <Layout>
                  <Team />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/subteam"
            element={
              <ProtectedRoute allowedRoles={["manager", "admin"]}>
                <Layout>
                  <Msubteam />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/Msubteam"
            element={
              <ProtectedRoute allowedRoles={["manager"]}>
                <Layout>
                  <Msubteam />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/department"
            element={
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <Layout>
                  <Department />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/task"
            element={
              <ProtectedRoute allowedRoles={["manager", "Team Leader", "admin"]}>
                <Layout>
                  <TaskPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/workflowupdate/:mode?"
            element={
              <ProtectedRoute allowedRoles={["manager", "employee", "Team Leader"]}>
                <Layout>
                  <TaskUpdate />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
